import { render, staticRenderFns } from "./InnovativeFeaturesSection.vue?vue&type=template&id=bd4ab572&scoped=true&"
import script from "./InnovativeFeaturesSection.vue?vue&type=script&lang=js&"
export * from "./InnovativeFeaturesSection.vue?vue&type=script&lang=js&"
import style0 from "./InnovativeFeaturesSection.vue?vue&type=style&index=0&id=bd4ab572&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4ab572",
  null
  
)

export default component.exports